import { render, staticRenderFns } from "./ShowDialogCharla.vue?vue&type=template&id=44f63a4c&scoped=true"
import script from "./ShowDialogCharla.vue?vue&type=script&lang=js"
export * from "./ShowDialogCharla.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogCharla.vue?vue&type=style&index=0&id=44f63a4c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f63a4c",
  null
  
)

export default component.exports